export const FILE_STATUS = {
  Uploaded: '파일 추출 대기 중',
  Labeling: '편집 대기 중',
  Embedded: '답변 가능',
  Error: '추출 오류',
};
